import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreMaterialModule } from '@nttp/core-material';
import { CoreUiModule } from '@nttp/core-ui';
import { ManageUserComponent } from '@pg-app/partner/manage-user/containers/manage-user.component';
import { ManageUserRoutingModule } from '@pg-app/partner/manage-user/manage-user.routing';
import { ManageUserService } from '@pg-app/partner/manage-user/services/manage-user.service';
import { NgTableModule } from '@nttp/table/ng-table.module';
import { CommonDialogModule } from '@pg-app/common/common-dialog-module.module';

@NgModule({
  declarations: [ManageUserComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CoreMaterialModule,
    ManageUserRoutingModule,
    NgTableModule,
    CoreUiModule,
    CommonDialogModule
  ],
  providers: [
    ManageUserService
  ],
  bootstrap: []
})
export class ManageUserModule { }
